import React, { useState } from 'react';
import { Loader2, RotateCcw } from 'lucide-react';
import { ordersAPI, OrderResponse } from '../../lib/api';
import { Button } from '../ui/button';

interface Props {
    order: OrderResponse;
    onReset: (order: OrderResponse) => void;
    onError: (message: string) => void;
}

export const ResetOrderButton: React.FC<Props> = ({ order, onReset, onError }) => {
    const [busy, setBusy] = useState(false);
    if (order.order_type !== 'deposit' || order.status !== 'active') return null;

    const reset = async () => {
        setBusy(true);
        try {
            const updated = await ordersAPI.resetAccumulated(order.id);
            onReset(updated);
        } catch (error: any) {
            onError(error.response?.data?.detail || 'Не удалось обнулить накопленную сумму');
        } finally {
            setBusy(false);
        }
    };

    return (
        <Button variant="outline" size="sm" onClick={reset}
            disabled={busy || !order.accumulated_amount}
            title="Освободить объём завершённых платежей. История и активные сделки сохранятся.">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <RotateCcw className="h-4 w-4" />}
            Обнулить
        </Button>
    );
};
